import React from 'react'
import Header from './Common/Header'
import Footer from './Common/Footer'
import { useLocation } from "react-router-dom";

const Layout = ({ children }) => {
  const location = useLocation();

  // Check the current URL path
  const isChatPage = location.pathname === "/chat";
  return (
    <>
      <Header />
      <section className={isChatPage ? "main-wrap pb-1" : "main-wrap"}>
        <div className='container-fluid'>
          {children}
        </div>
      </section>
      <Footer />
    </>
  )
}

export default Layout